import { buildCustomerPath } from "./customer";

export const PCF_ROUTE_SEGMENTS = {
  root: "pcf",
  uploadTemplate: "upload-template",
  calculationId: ":calculationId",
} as const;

export const buildPcfOverviewPath = (customerId: string): string =>
  `${buildCustomerPath(customerId)}/${PCF_ROUTE_SEGMENTS.root}`;

export const buildPcfUploadTemplatePath = (customerId: string): string =>
  `${buildPcfOverviewPath(customerId)}/${PCF_ROUTE_SEGMENTS.uploadTemplate}`;

export const buildPcfCalculationPath = (customerId: string, calculationId: string): string =>
  `${buildPcfOverviewPath(customerId)}/${calculationId}`;
